import { CrossIcon, PaperClipIcon } from "Assets/icons/v2";
import GreySvgCross from "Assets/images/GreySvgCross";
import LoadingIndicator from "components/shared/LoadingIndicator";
import React, { useEffect, useRef, useState } from "react";
import { useUploadFileMutation } from "store/services/utility";

function FilePicker({ value, onChange, wrapper, acceptedTypes = "image/png, image/jpeg, image/jpg,application/pdf" }) {
    const [uploadFile, { isLoading: fileLoading }] = useUploadFileMutation();

    const fileRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const [preview, setPreview] = useState(null);

    // Sync value (File or string)
    useEffect(() => {
        if (value) {
            setFileName(value?.name || value);

            // Preview logic
            if (typeof value === "string") {
                setPreview(value);
            } else {
                setPreview(URL.createObjectURL(value));
            }
        } else {
            setFileName("");
            setPreview(null);
        }

        return () => {
            if (preview && typeof value !== "string") {
                URL.revokeObjectURL(preview);
            }
        };
    }, [value]);

    const handleClick = () => {
        fileRef.current?.click();
    };

    const handleChange = async (e) => {
        const file = e.target.files?.[0];
        if (file) {
            const resp = await uploadFile({ file, acl: "public-read", fileOriginalFormat: true }).unwrap()
            if (resp && typeof onChange === "function") {
                onChange(resp);
                setPreview(resp)
            }
        }
    };

    const handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onChange(null);
        setFileName("");
        setPreview(null);

        if (fileRef.current) {
            fileRef.current.value = "";
        }
    };

    return (
        <div style={{ width: "299px", ...wrapper }}>
            {/* Image Preview */}

            {
                fileLoading ? <LoadingIndicator /> : (
                    preview && (
                        <img
                            src={preview}
                            alt=""
                            height={88}
                            className="mb-3 d-block"
                        />
                    )
                )
            }
            {/* File Picker */}
            <div className="doc-input">
                <div
                    className="input-container cursor-pointer"
                    onClick={handleClick}
                >
                    <span
                        className={`text-truncate me-2 ${fileName ? "text-dark" : "text-muted"
                            }`}
                        style={{ maxWidth: "calc(100% - 32px)", fontSize: "14px" }}
                        title={fileName}
                    >
                        {fileName || ""}
                    </span>

                    {!fileName && <PaperClipIcon className="flex-shrink-0" />}
                </div>

                {/* Single Remove Icon */}
                {value && (
                    <span
                        className="cursor-pointer text-danger"
                        onClick={handleRemove}
                    >
                        <GreySvgCross />
                    </span>
                )}
            </div>

            {/* Hidden input */}
            <input
                ref={fileRef}
                type="file"
                accept={acceptedTypes}
                className="d-none"
                onChange={handleChange}
            />
        </div>
    );
}

export default FilePicker;
